import accountReceivableReducer from "./accountReceivableReducer";


const accountStatementReducers = {
    accountReceivable: accountReceivableReducer,
}

export default accountStatementReducers;